import { TableCell, TableRow, TableRowProps } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { FONT } from "../../../../constants/common";
import ShowFormValue from "./ShowFormValue";
import formStore from "../../../../store/formStore";
import { TFormColumn, TRequiredKey } from "../../../common/components/types";
import useObserver from "../../../helpers/form/useObserver";
import FormTitle from "./FormTitle";
import ShowExternalDBValue from "./ShowExternalDBValue";

const useStyles = makeStyles(() => ({
  th: {
    fontFamily: FONT,
    fontWeight: 900,
    backgroundColor: "#fff",
    color: "#000!important",
    width: 263,
    borderBottom: "2px dotted #ddd",
    position: "relative",
  },
  td: {
    backgroundColor: "#fff",
    color: "#000!important",
    borderBottom: "2px dotted #ddd",
    width: 200,
  },
}));

type Props = TableRowProps & {
  columnName: TFormColumn;
  requiredKey: TRequiredKey;
  terminalGridId: number | undefined;
  gridId: number | undefined;
};
const ChangeDealConfirmFormValueRow: React.FC<Props> = (props: Props) => {
  const { columnName, requiredKey, terminalGridId, gridId, className } = props;
  const [init, setInit] = useState(false);
  const [isHide, setHide] = useState(
    formStore.isHideRowForChangeRequest(columnName, requiredKey)
  );
  const target = React.useRef<HTMLTableRowElement>(null);
  // 描画境界判定
  const intersect = useObserver(target, {
    root: document.getElementById("scroll-parent"), // TabPanel
    rootMargin: "300px 0px 300px 0px", // 上下300px広く判定
  });

  const classes = useStyles();

  useEffect(() => {
    // タブ切り替え時に"scroll-parent"がDOMについたあとuseObserverするため
    setInit(true);
    setHide(!formStore.isChangeableColumnName(columnName));
  }, [columnName]);

  if (isHide) return null;

  return init ? (
    <TableRow
      className={className}
      key={columnName}
      innerRef={target}
      style={{
        height: intersect
          ? "auto"
          : "75px" /* 描画範囲外の場合は仮で高さを設定しておく */,
      }}
    >
      <TableCell align="left" className={classes.th}>
        <FormTitle
          columnName={columnName}
          requiredKey={requiredKey}
          isChangeDeal
        />
      </TableCell>
      <TableCell align="left" className={classes.td}>
        {intersect ? (
          <ShowFormValue
            columnName={columnName}
            terminalGridId={terminalGridId}
            gridId={gridId}
          />
        ) : null}
      </TableCell>
      <TableCell align="left" className={classes.td}>
        {intersect ? (
          <ShowExternalDBValue
            columnName={columnName}
            terminalGridId={terminalGridId}
            gridId={gridId}
            dbName="jtbApproved"
          />
        ) : null}
      </TableCell>
      <TableCell align="left" className={classes.td}>
        {intersect ? (
          <ShowExternalDBValue
            columnName={columnName}
            terminalGridId={terminalGridId}
            gridId={gridId}
            dbName="centerReflected"
          />
        ) : null}
      </TableCell>
      <TableCell align="left" className={classes.td}>
        {intersect ? (
          <ShowExternalDBValue
            columnName={columnName}
            terminalGridId={terminalGridId}
            gridId={gridId}
            dbName="centerToBeReflected"
          />
        ) : null}
      </TableCell>
    </TableRow>
  ) : null;
};

export default ChangeDealConfirmFormValueRow;
